/** Debounce delay for contact search queries (ms) */
export const SEARCH_DEBOUNCE_MS = 300;

/** Default page size for transfer contact search */
export const TRANSFER_CONTACTS_LIMIT = 20;

/** Allowed characters in a phone-number query (digits, +, *, #, and formatting). */
export const PHONE_NUMBER_PATTERN = /^[\d+*# \-().]+$/;

/** Pattern matching a single dialable character (digit, +, *, #) */
export const DIALABLE_CHAR_PATTERN = /[\d+*#]/;

/**
 * Minimum number of dialable characters required to show the direct
 * number option (e.g. "(7)" — 3 chars but 1 digit — does not qualify).
 */
export const MIN_DIRECT_NUMBER_LENGTH = 3;
